import React from "react";
import Drivers from "./Drivers";

function DriversDetail() {
  return <Drivers />;
}

export default DriversDetail;
